<template>
  <div class="container">
    <head-nav-bar :title="title" :fixed="true" @click-left="$router.go(-1)" />
    <div class="mt-header-nav">
      <div class="kong"></div>
      <van-cell-group>
        <van-field
          v-model="form.patientName"
          required
          :readonly="true"
          clearable
          label="姓名："
          placeholder="请输入真实姓名"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="form.identityDocTypeDesc"
          readonly
          class="readonly"
          label="证件类型："
          placeholder="点击此处选择"
          @click="showSelectType"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="form.identityNo"
          class="readonly"
          :readonly="type === 'healthCard'"
          label="证件号码："
          clearable
          placeholder="点击输入"
          :error-message="idCardErrorMsg"
          @blur="onIdentityNoChange"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="form.birthday"
          readonly
          required
          label="出生日期："
          placeholder="点击此处选择"
          @click="showSelectDate"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="form.sex"
          readonly
          class="readonly"
          label="性别："
          placeholder="点击此处选择"
          @click="showSelectSex"
        />
      </van-cell-group>

      <van-cell-group>
        <van-field
          v-model="form.mobilePhone"
          label="手机号码："
          clearable
          :readonly="type === 'healthCard'"
          required
          placeholder="点击输入"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          v-model="form.familyPhone"
          label="家属电话："
          clearable
          placeholder="点击输入"
        />
      </van-cell-group>
      <van-field
        v-if="sysParams.enabledAddressSelect"
        v-model="form.addDetail"
        is-link
        readonly
        required
        label="省市区"
        placeholder="请选择所在地区"
        @click="show = true"
      />
      <van-popup v-model="show" round position="bottom">
        <van-cascader
          v-model="cascaderValue"
          title="请选择所在地区"
          :options="options"
          :field-names="fieldNames"
          @close="show = false"
          @finish="onFinish"
        />
      </van-popup>

      <van-cell-group>
        <van-field
          v-model="form.contactAddress"
          clearable
          label="详细地址"
          required
          placeholder="选填"
        />
      </van-cell-group>

      <van-cell-group>
        <van-field
          v-model="form.native"
          readonly
          class="readonly"
          label="籍贯："
          placeholder="点击此处选择"
          @click="showNativePicker"
        />
        <van-field
          v-model="form.nation"
          readonly
          class="readonly"
          label="民族："
          placeholder="点击此处选择"
          @click="showNationPicker"
        />
        <van-field
          v-model="form.marry"
          readonly
          class="readonly"
          label="婚姻状态："
          placeholder="点击此处选择"
          @click="showMarryPicker"
        />
      </van-cell-group>

      <div class="kong"></div>
      <van-cell-group v-if="isMinorChild">
        <van-field
          v-model="form.parentName"
          label="监护人姓名："
          clearable
          required
          placeholder="点击输入"
        />
        <van-field
          v-model="form.parentIdNo"
          label="监护人身份证:"
          clearable
          required
          placeholder="点击输入"
        />
      </van-cell-group>
      <div v-if="isMinorChild" class="kong"></div>

      <van-notice-bar wrapable :scrollable="false">
        <!-- 本院为实名制就诊,为保障您的权益,请如实填写就诊人信息.若输入正确姓名、身份证、仍无法开卡，请前往线下人工收费窗口办理。 -->
        <p>注意： 带*的为必填项</p>
        <p>1、如遇办卡异常，可取消关注后，重新关注即可。</p>
        <p>2、就诊卡各环节无需实体就诊卡，出示电子就诊卡即可。</p>
        <p>3、电子就诊卡不会丢失，可长期使用。</p>
        <p>4、领取电子就诊卡无需办卡费。</p>
        <p>5、每位微信用户可以最多绑定6张卡</p>
      </van-notice-bar>

      <div class="box" style="margin-top: 0.5rem">
        <van-button
          type="info"
          block
          :disabled="disabled"
          :loading="loading"
          @click="onSubmit"
          >确认保存</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  Field,
  Cell,
  CellGroup,
  Toast,
  NoticeBar,
  Button,
  Notify,
  Cascader,
  Popup,
} from "vant";
import SelectPicker from "@/components/select-picker/function";
import DateTimePicker from "@/components/date-time-picker/function";
import {
  getSelectData,
  IdentityCodeValid,
  getAges,
  checkPhone,
} from "@/utils/common";
export default {
  name: "userContactInfo",
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [NoticeBar.name]: NoticeBar,
    [Button.name]: Button,
    [Cascader.name]: Cascader,
    [Popup.name]: Popup,
  },
  data() {
    return {
      show: false,
      cascaderValue: "",
      // 选项列表，children 代表子选项，支持多级嵌套
      fieldNames: {
        text: "name",
        value: "code",
        children: "items",
      },
      options: [],
      title: "添加就诊人",
      selectData: {},
      disabled: false,
      idCardErrorMsg: "",
      SelectPickerModal: "",
      loading: false,
      form: {
        id: 0,
        // IdentityDocType: "10",
        // IdentityDocTypeDesc: "居民身份证",
        identityNo: "",
        patientName: "",
        birthday: "",
        cardholderSex: "",
        identityDocType: "",
        identityDocTypeDesc: "",
        sexId: "1",
        mobilePhone: "",
        sex: "",
        identityValue: "",
        familyPhone: "",
        addDetail: "",
        native: "",
        nation: "",
        marry: "未婚",
      },
      query: {},
      sysParams: {},
      isMinorChild: false,
      type: "",
    };
  },
  mounted() {
    this.query = this.$route.query;
    if (this.query.type) {
      this.type = this.query.type;
    }
    this.init();
    this.getAddressData();
  },
  beforeDestroy() {
    this.SelectPickerModal && this.SelectPickerModal.cancel();
  },
  methods: {
    getAddressData() {
      this.$post("His_GetAddressList", {}).then((res) => {
        const addObj = res.data;
        let options = [];
        options = addObj.provinceList;
        for (let i = 0; i < addObj.provinceList.length; i++) {
          addObj.provinceList[i].items = [];
          for (let j = 0; j < addObj.cityList.length; j++) {
            addObj.cityList[j].items = [];
            if (addObj.cityList[j].parentCode == addObj.provinceList[i].code) {
              addObj.provinceList[i].items.push(addObj.cityList[j]);
            }
            for (let k = 0; k < addObj.countyList.length; k++) {
              if (addObj.countyList[k].parentCode == addObj.cityList[j].code) {
                addObj.cityList[j].items.push(addObj.countyList[k]);
              }
            }
          }
        }
        this.options = options;
      });
    },
    onFinish({ selectedOptions }) {
      this.show = false;
      this.form.addDetail = selectedOptions
        .map((option) => option.name)
        .join("/");
    },
    init() {
      this.title = "自助办理电子健康卡";
      this.$post("GetWxSystemParameterInfo", {}).then((res) => {
        this.sysParams = res.data;
      });
      getSelectData([
        "IdentityDocTypeDic",
        // "CardType",
        "SexType",
        "Native",
        "Nation",
      ]).then((res) => {
        this.selectData = res;
        res.IdentityDocTypeDic.map((p) => {
          if (p.value == "1") {
            this.form.identityValue = p.value;
            this.form.identityDocType = p.id;
            this.form.identityDocTypeDesc = p.text;
          }
        });
        if (this.$route.query.identityNo && this.$route.query.name) {
          this.form.identityNo = this.$route.query.identityNo;
          this.form.patientName = this.$route.query.name;
          const verifyIdCard = IdentityCodeValid(this.form.identityNo);
          if (verifyIdCard && verifyIdCard.state == "success") {
            this.form.sexId = verifyIdCard.sex;
            const sexFind = res.SexType.find(
              (p) => p.value == verifyIdCard.sex
            );
            if (sexFind && sexFind.text) {
              this.form.sex = sexFind.text;
            }
            this.setBirthday(verifyIdCard.birthday);
          }
        }
        if (this.selectData.Native && this.selectData.Native.length) {
          this.form.native = this.selectData.Native[0].text;
        }
        if (this.selectData.Nation && this.selectData.Nation.length) {
          this.form.nation = this.selectData.Nation[0].text;
        }
        if (this.$route.query.mobilePhone) {
          this.form.mobilePhone = this.$route.query.mobilePhone;
        }
        if (this.$route.query.contactAddress) {
          this.form.contactAddress = this.$route.query.contactAddress;
        }
        if (this.$route.query.birthday) {
          this.form.birthday = this.$route.query.birthday;
        }
        if (this.$route.query.sex) {
          this.form.sex = this.$route.query.sex;
        }
      });
    },

    showSelectDate() {
      if (this.type === "healthCard") {
        return;
      }
      const time = this.form.birthday ? this.form.birthday : "2000-01-01";
      this.SelectPickerModal = DateTimePicker({
        value: time,
        format: "yyyy-MM-dd",
        change: this.setBirthday,
      });
    },
    setBirthday(data) {
      this.form.birthday = data;
      const age = getAges(this.form.birthday);
      if (this.sysParams.minorChildAge && age <= this.sysParams.minorChildAge) {
        // 未成年
        this.isMinorChild = true;
      } else {
        this.isMinorChild = false;
        this.form.parentName = "";
        this.form.parentIdNo = "";
      }
    },

    showSelectSex() {
      if (this.type === "healthCard") {
        return;
      }
      this.SelectPickerModal = SelectPicker({
        columns: this.selectData.SexType,
        defaultValue: this.form.cardholderSex,
        change: (data) => {
          this.form.sexId = data.id;
          this.form.sex = data.text;
        },
      });
    },
    showSelectType() {
      if (this.type === "healthCard") {
        return;
      }
      this.SelectPickerModal = SelectPicker({
        columns: this.selectData.IdentityDocTypeDic,
        defaultValue: this.form.identityDocType,
        change: (data) => {
          this.form.identityValue = data.value;
          this.form.identityDocType = data.id;
          this.form.identityDocTypeDesc = data.text;
        },
      });
    },
    showNativePicker() {
      this.SelectPickerModal = SelectPicker({
        columns: this.selectData.Native,
        defaultValue: this.form.native,
        change: (data) => {
          this.form.native = data.text;
        },
      });
    },
    showNationPicker() {
      this.SelectPickerModal = SelectPicker({
        columns: this.selectData.Nation,
        defaultValue: this.form.nation,
        change: (data) => {
          this.form.nation = data.text;
        },
      });
    },
    showMarryPicker() {
      this.SelectPickerModal = SelectPicker({
        columns: [
          {
            id: "未婚",
            text: "未婚",
          },
          {
            id: "已婚",
            text: "已婚",
          },
        ],
        defaultValue: this.form.marry,
        change: (data) => {
          this.form.marry = data.text;
        },
      });
    },
    onIdentityNoChange(e) {
      // if (this.form.identityDocTypeDesc != "居民身份证") {
      //   return;
      // }
      if (this.form.identityValue != "1") {
        return;
      }

      const value = e.target.value;
      // if (value && this.form.IdentityDocType == "10") {
      const verifyIdCard = IdentityCodeValid(value);
      if (verifyIdCard && verifyIdCard.state === "success") {
        this.idCardErrorMsg = "";
        // 自动填写 生日 性别
        this.form.sexId = verifyIdCard.sex;
        this.form.sex = verifyIdCard.sex == 1 ? "男" : "女";
        // this.form.birthday = verifyIdCard.birthday;
        this.setBirthday(verifyIdCard.birthday);
      } else {
        this.idCardErrorMsg = verifyIdCard.msg;
      }
      // }
    },

    onSubmit() {
      //验证
      const verifyRes = this.verifyForm();
      if (verifyRes === false) {
        return false;
      }
      this.form.sexId = String(this.form.sexId);
      this.loading = true;

      const add = this.form.addDetail.split("/");
      this.form.addrProvince = add[0];
      this.form.addrCity = add[1];
      this.form.addrCounty = add[2];
      this.$post("SelfAddNewDiagnosisCard", this.form)
        .then((res) => {
          if (res.data.result) {
            Toast.success(res.data.message);
            this.loading = false;
            if (this.query && this.query.fromPathName) {
              this.$router.push({
                name: this.query.fromPathName,
                replace: true,
              });
            } else {
              this.$router.push({ name: "userContactList", replace: true });
            }
          } else {
            this.loading = false;
            Toast.fail(res.data.message);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    verifyForm() {
      const verifyFields = [
        "patientName",
        "birthday",
        "sexId",
        "mobilePhone",
        "identityNo",
        "contactAddress",
      ];
      let is = false;
      for (let i = 0; i < verifyFields.length; i++) {
        const item = verifyFields[i];
        if (!this.form[item]) {
          is = true;
        }
        if (item == "identityNo") {
          const verifyIdCard = IdentityCodeValid(this.form[item]);
          if (
            verifyIdCard &&
            verifyIdCard.state !== "success" &&
            this.form.identityDocTypeDesc == "身份证"
          ) {
            Notify(verifyIdCard.msg);
            is = true;
            return false;
          }
        }
        if (item == "contactAddress") {
          const verifyIdCard = this.form[item];
          if (!verifyIdCard || (verifyIdCard && verifyIdCard.length < 8)) {
            Notify("联系地址不得少于8个汉字！");
            return false;
          }
        }
        if (item == "patientName") {
          const verifyIdCard = this.form[item];
          //判断姓名不能有特殊符号
          var regEn = /[`~!@#$%^&*()_+<>?:"{},./;'[\]]/im,
            regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;

          if (regEn.test(verifyIdCard) || regCn.test(verifyIdCard)) {
            Notify("姓名不能包含特殊字符.");
            return false;
          }
        }
        if (item == "mobilePhone") {
          // 验证手机号
          if (!checkPhone(this.form[item])) {
            Notify("请输入正确的手机号码");
            return false;
          }
        }
      }
      // 验证家属手机号
      if (this.form.familyPhone && !checkPhone(this.form.familyPhone)) {
        Notify("请输入正确的家属电话号码");
        return false;
      }
      if (is) {
        Notify("带*号必填，请完善信息！");
        return false;
      }

      if (
        this.isMinorChild &&
        !(this.form.parentName && this.form.parentIdNo)
      ) {
        // 未成年
        Notify("带请完善监护人信息！");
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.van-field__label {
  width: 6.5em;
}
</style>
